var Theme = Theme || {};

// is in viewport
function inViewport(elem, callback, options = {}) {
    return new IntersectionObserver(entries => {
        entries.forEach(entry => callback(entry))
    }, options).observe(document.querySelector(elem));
}

/* How to inViewport
document.addEventListener("DOMContentLoaded", () => {
    inViewport('[data-inviewport]', element => {
        if (!element.isIntersecting) { document.querySelector('#add2cart-cta').classList.add('active') } 
        else { document.querySelector('#add2cart-cta').classList.remove('active') }
    });
});
*/

// Toggle Body Class
let toggleBodyClass = function(arg) { 
    document.body.classList.toggle(arg);
}
// Get Element Height
function getElementHeight(targetElement,appendTo,cssVar) {
    let element = document.querySelector(targetElement);

    if (element) {
        let elementHeight = element.offsetHeight;
        document.querySelector(appendTo).style.setProperty(cssVar, `${elementHeight}px`);
    }
}

// Browser check
// Browser and device detection
function getNavigator() {
    const html = document.documentElement;

    // Feature-based detection
    const isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const isSafari = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
    const isChrome = /Chrome/.test(navigator.userAgent) && !/Edge|Edg/.test(navigator.userAgent);
    const isFirefox = /Firefox/.test(navigator.userAgent);
    const isEdge = /Edge|Edg/.test(navigator.userAgent);
    
    // Touch support detection
    const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    
    // Apply classes
    if (isiOS) html.classList.add('ios');
    if (hasTouch) html.classList.add('touch');
    
    // Browser classes and events
    const browsers = [
        { test: isSafari, name: 'safari' },
        { test: isChrome, name: 'chrome' },
        { test: isFirefox, name: 'firefox' },
        { test: isEdge, name: 'edge' }
    ];
    
    browsers.forEach(({ test, name }) => {
        if (test) {
            html.classList.add(name);
            window.dispatchEvent(new CustomEvent('user-agent', { detail: { browser: name } }));
        }
    });
}

// Menu
    function onMenuClick() {
        toggleBodyClass('open-menu');
    }

    function toggleMenu(root = document) {
        for (const trigger of root.querySelectorAll('.fire-menu, .shrink-menu')) {
            trigger.addEventListener('click', onMenuClick);
        }
    }

    function onDetailsClick(event) {
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    }

    function a11yDetails(root = document) {
        for (const summary of root.querySelectorAll('[id^="Details-"] summary')) {
            summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
            
            if(summary.nextElementSibling.getAttribute('id')) {
                summary.setAttribute('aria-controls', summary.nextElementSibling.id);
            }
            
            summary.addEventListener('click', onDetailsClick);
        }
    }

// Bullet marquee
if (!customElements.get('bullet-marquee')) customElements.define('bullet-marquee', class bulletMarquee extends HTMLElement {
    connectedCallback() {
        if (!window.ResizeObserver) return;
        this._resizeObserver = new ResizeObserver(this.duration.bind(this));
        this._resizeObserver.observe(this);
    }

    disconnectedCallback() {
        this._resizeObserver?.disconnect();
        this._resizeObserver = null;
    }

    duration(entries) {
        const scrollingSpeed = parseInt(this.getAttribute('bullet-speed') || 5);
        const contentWidth = entries[0].contentRect.width;
      
        // Calculate the slowFactor based on content width
        let slowFactor = contentWidth <= 375 ? 1 : contentWidth >= 1280 ? 3 : 1 + (contentWidth - 375) / (1280 - 375);

        // Calculate the scrolling speed with the adjusted slowFactor
        const scrollingDuration = (scrollingSpeed * slowFactor * entries[0].target.querySelector('span').clientWidth / contentWidth).toFixed(3);

        this.style.setProperty('--bullet-speed', `${scrollingDuration}s`);
    }
});

/***
    === [ CORETEX FYI ] ===
    Shopify standard actions bridge

    Routes app-triggered Shopify.actions calls (updateCart, openCart) through
    Liquid Ajax Cart so the theme cart UI updates without page reloads.
*/

// # Re-sync Liquid Ajax Cart after an app mutated the cart via the Storefront API.
// Runs thru the library queue so cart state, bindings and data-ajax-cart-section containers re-render.
let _standardActionSyncQueued = false;
function _syncAjaxCartFromStandardAction() {
    const sync = () => {
        _standardActionSyncQueued = false;
        window.liquidAjaxCart.update({});
    };
    if (window.liquidAjaxCart?.init) {
        sync();
    } else if (!_standardActionSyncQueued) {
        _standardActionSyncQueued = true;
        document.addEventListener('liquid-ajax-cart:init', sync, { once: true });
    }
}

// # Configure the standard actions to use the theme cart UI
function _configureStandardActions() {
    const actions = window.Shopify?.actions;
    if (!actions) return;

    try {
        actions.updateCart?.configure?.({
            eventTarget: (meta) => {
                if (meta?.action === 'add') return document.querySelector('ajax-cart-product-form') || document.body;
                return document.querySelector('[data-ajax-cart-section]') || document.body;
            },
            async handler(defaultHandler) {
                const result = await defaultHandler();
                if (!result?.userErrors?.length) _syncAjaxCartFromStandardAction();
                return result;
            },
        });

        actions.openCart?.configure?.({
            handler() {
                const cartUrl = window.routes?.cart_url || '/cart';
                if (window.location.pathname === cartUrl) {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                } else if (window.cartSettings?.type === 'redirect') {
                    window.location.href = cartUrl;
                } else {
                    const cartBox = document.getElementById('cartBox');
                    if (typeof cartBox?.open === 'function') cartBox.open();
                    else window.location.href = cartUrl;
                }
            },
        });
    } catch (error) {
        // Never let a Shopify.actions API change break the storefront
        console.warn('Standard cart actions bridge skipped:', error);
    }
}

// Shopify injects standard-actions.js as a module at the END of <body>, so it runs
// after this deferred file, wait for DOMContentLoaded (fires after all deferred/module
// scripts). configure() is first-wins and never throws, so repeat calls are harmless.
if (document.readyState === 'complete') {
    _configureStandardActions();
} else {
    document.addEventListener('DOMContentLoaded', _configureStandardActions, { once: true });
    window.addEventListener('load', _configureStandardActions, { once: true });
}

// Hide the sticky header when scrolling down and reveal it when scrolling up.
let _hideOnScrollTarget = null;
let _hideOnScrollController = null;

function destroyHideOnScroll() {
    _hideOnScrollController?.abort();
    _hideOnScrollController = null;
    _hideOnScrollTarget = null;
}

function initHideOnScroll() {
    const marker = document.querySelector('[hide-on-scroll]');
    const target = marker?.parentElement;
    if (target === _hideOnScrollTarget) return;
    destroyHideOnScroll();
    if (!target) return;
    _hideOnScrollTarget = target;
    _hideOnScrollController = new AbortController();
    const { signal } = _hideOnScrollController;

    let lastScrollY = window.scrollY;
    const update = () => {
        const scrollY = window.scrollY;
        const hidden = scrollY > lastScrollY
            && scrollY > target.offsetHeight
            && !target.contains(document.activeElement);
        target.setAttribute('hide-on-scroll-target', hidden ? 'hidden' : '');
        lastScrollY = scrollY;
    };

    target.setAttribute('hide-on-scroll-target', '');
    target.addEventListener('focusin', () => target.setAttribute('hide-on-scroll-target', ''), { signal });
    window.addEventListener('scroll', update, { passive: true, signal });
}

/*** init app */
// Code to be executed when DOM is ready.
(() => {
    function initApp(root = document) {
        toggleMenu(root); // toggle Menu
        a11yDetails(root); // initialize accessibility for details elements
        initHideOnScroll(); // hide on scroll
    }

    // Code to be executed when DOM is ready.
    document.addEventListener('DOMContentLoaded', () => {
        getNavigator();
        initApp();
    });

    // Code to be executed when in the theme editor
    if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', (event) => initApp(event.target));
        document.addEventListener('shopify:section:unload', (event) => {
            if (event.target.contains(_hideOnScrollTarget)) destroyHideOnScroll();
        });
    }
})();
